export const TABS = {
  ALL: "all",
  ACTIVE: "active",
  ARCHIVED: "archived",
};

export const PAGINATION_LIMIT_THRESHOLD = 1000;
